/* RESPONSIBLE TEAM: team-standalone */

import type { ConversationExcerptData } from '../definitions';
import type Platform from '../../platform';

export default class GenericConversationExcerpt implements ConversationExcerptData {
  private platform: Platform;

  constructor(platform: Platform) {
    this.platform = platform;
  }

  title(excerptsEnabled: boolean) {
    let defaultPrefix = 'fin-ai-agent.knowledge.content-sources.conversation-excerpts';
    let prefix = excerptsEnabled ? `${defaultPrefix}.enabled` : defaultPrefix;
    return this.platform.intl.t(`${prefix}.default`);
  }

  get link() {
    return undefined;
  }
}
